import { memo } from "react";

// product specification
import Specification from "./Specification";

const SpecificationList = ({
  list = [],
  removeWorkingAreaSpecification = () => { },
}) => list.map((item) => (
  <Specification
    key={item.article}
    data={item}
    remove={removeWorkingAreaSpecification}
  />
));

export default memo(SpecificationList);
